import type { RequestInit } from "next/dist/server/web/spec-extension/request";

import { getRevalidateTime } from "./getRevalidateTime";
import { isFetchCacheEnabled } from "./isFetchCacheEnabled";
import type { FetchCacheTag } from "./tags";

export const createFetchCacheConfig = (options?: Options): Pick<RequestInit, "cache" | "next"> => {
  const { cachePolicy, revalidateTimeMinutes = 30, tags } = options ?? {};

  return {
    cache: cachePolicy ?? getDefaultCachePolicy(),
    next: {
      revalidate: getRevalidateTime(revalidateTimeMinutes),
      tags,
    },
  };
};

const getDefaultCachePolicy = (): RequestCache => (isFetchCacheEnabled() ? "force-cache" : "no-store");

type Options = {
  cachePolicy?: RequestCache;
  revalidateTimeMinutes?: number;
  tags?: FetchCacheTag[];
};
